import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <div className="Footer">
      <div className='upper-section'>
      <div className='contacts'>
        <img src={require('../assets/InTimeLink_logo_white.png')}></img>
        <span className='strong big'>In Time Link Srl</span>
        <span className='strong'>Sede Legale</span>
        <span>Via Marsala 29/H - 00185 Rome - Italy</span>
        <span>VAT ID 14396101009</span>
        <span>Camera di commercio di Roma</span>
        <br></br>
        <span className='strong'>Sede Operativa</span>
        <span>Via XX Settembre 34 - 50056 Montelupo F.no (FI) - Italy</span>
      </div>
        {/* <ul>
          <li><Link to="/">Home</Link></li>
          <li><Link to="/crypto">Crypto</Link></li>
          <li><Link to="/retail">Retail</Link></li>
          <li><Link to="/vending">Vending</Link></li>
          <li><Link to="/BI">Business Intelligence</Link></li>
          <li><Link to="/contacts">Contacts</Link></li>
        </ul> */}
      </div>
    </div>
  );
}

export default Footer;
